import React from 'react'

const Maps = () => {
  return (
    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14235.767706805576!2d81.0191745!3d26.8735861!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be30d8c1ea8e3%3A0xc51e5d51d90b79fc!2sMask%20Hospital%20Gomti%20Nagar%20Lucknow!5e0!3m2!1sen!2sin!4v1699256716000!5m2!1sen!2sin"  style={{width:"100%",height:'400px'}}   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  )
}

export default Maps